import { useEffect } from 'react';

import { useNhanDien } from '../../modules/ho-so-to-chuc/hooks/useNhanDien';

/** Tiêu đề gốc ở `index.html`, trả về khi tổ chức không có tên hoặc khi rời khỏi layout. */
const TIEU_DE_GOC = 'FOXAI Native';

/**
 * Đưa tên và favicon của tổ chức lên tab trình duyệt (ADR-UI-0016 mục 4).
 *
 * Không vẽ gì. Tiêu đề và `<link rel="icon">` nằm ngoài cây React nên phải ghi
 * bằng tay; đó là lý do duy nhất ở đây dùng `useEffect`: đồng bộ với một hệ
 * thống bên ngoài, và dọn lại đúng như cũ khi tổ chức đổi hoặc component gỡ.
 */
export function DongBoNhanDien() {
  const { ten, faviconUrl } = useNhanDien();

  useEffect(() => {
    if (!ten) return;
    document.title = ten;
    return () => {
      document.title = TIEU_DE_GOC;
    };
  }, [ten]);

  useEffect(() => {
    if (!faviconUrl) return;
    let link = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');
    const tuTao = link === null;
    const hrefCu = link?.getAttribute('href') ?? null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
    return () => {
      if (tuTao) link.remove();
      else if (hrefCu !== null) link.setAttribute('href', hrefCu);
    };
  }, [faviconUrl]);

  return null;
}
